import type { VisitEstado } from '../api/types';

export function fmt(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return (
    d.toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' }) +
    ' ' +
    d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
  );
}

export function fmtC(iso?: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('es-AR', { day: '2-digit', month: 'short' });
}

const ESTADO_LABELS: Record<string, string> = {
  al_dia: 'Al día',
  por_vencer: 'Por vencer',
  vencida: 'Vencida',
  sin_visitas: 'Sin visitas',
  agendada: 'Agendada',
  en_curso: 'En curso',
  completada: 'Completada',
  cancelada: 'Cancelada',
  fallida: 'Fallida',
  pospuesta: 'Pospuesta',
};

export function eL(estado: string | VisitEstado): string {
  return ESTADO_LABELS[estado] || estado;
}

export function dur(a?: string | null, b?: string | null): number | null {
  if (!a || !b) return null;
  return Math.round((new Date(b).getTime() - new Date(a).getTime()) / 60000);
}
